import { useTranslation } from 'react-i18next'
import { PartialBrief } from '../../../../Types/Brief'
import { Currency } from '../../../../Types/generated-types'

interface BudgetProps {
  brief: PartialBrief
  supportedCurrencies: Currency[]
}

export const Budget = ({ brief, supportedCurrencies }: BudgetProps): JSX.Element => {
  const { t } = useTranslation('summaryPage')
  const currency = supportedCurrencies.find((c) => c.code === brief.currency)

  return (
    <>
      {t('summaryItems.budget', {
        currencySymbol: currency?.symbol,
        budget: brief.budget,
        budgetNotes: brief.budgetNotes,
      })}

      {brief.budgetNotes &&
        t('summaryItems.budgetNotes', {
          budgetNotes: brief.budgetNotes,
        })}
    </>
  )
}

export default Budget
